const set = require('regenerate')();
set.addRange(0x11180, 0x111DF).addRange(0x11B60, 0x11B67);
exports.characters = set;
